import { i18n } from "@libs/i18n";
import { LocationStatusType, LocationTypesType } from "@/domain/location";

export const formatLocationType = (type: LocationTypesType | undefined) => {
  switch (type) {
    case "OFFICE":
      return i18n.t("common:locationTypes.office");
    case "YARD":
      return i18n.t("common:locationTypes.yarn");
    case "PIT":
      return i18n.t("common:locationTypes.pit");
    case "DRIVE_TEST":
      return i18n.t("common:locationTypes.driveTest");
    case "VIRTUAL":
      return i18n.t("common:locationTypes.virtual");
    default:
      return i18n.t("common:other");
  }
};

export const formatLocationStatus = (
  status: LocationStatusType | undefined,
) => {
  switch (status) {
    case "ACTIVE":
      return i18n.t("common:active");
    case "INACTIVE":
      return i18n.t("common:inactive");
    default:
      return "";
  }
};

export const openMap = ({
  lat,
  lon,
  placeId,
}: {
  lat?: number | null;
  lon?: number | null;
  placeId?: string | null;
}) => {
  if (!lat || !lon || !placeId) return;

  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat}%2C-${lon}&query_place_id=${placeId}`;

  return window.open(mapsUrl, "_blank");
};
